<template>
  <div>
    <PageAllow controller="StockOuts" action="index" />
    <Breadcrumbs :items="items" />
    <!-- <v-slide-x-transition> -->
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="Exports()"
              >
                {{ $t("StockOuts.batch_export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="stock_order_code"
                    v-model="options.stock_order_code"
                    @text="stock_order_code = $event"
                    :label="$t('StockOuts.Fields.stock_order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4"> </v-col>
                <v-col cols="12" sm="6" md="4"> </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('StockOuts.outStatus.title')"
                    :items="$consts.outStatus"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.cancel_flgs"
                    :label="$t('StockOuts.Fields.cancel_flgs')"
                    :items="$consts.cancelFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>
      <div class="mx-4 mb-4">
        <v-data-table
          class="elevation-1 px-4 pt-1"
          :headers="headers"
          :items="stock_outs"
          :options.sync="options"
          :page.sync="paging.page"
          :loading="loading"
          :server-items-length="paging.count"
          multi-sort
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.name>
            {{ accountName }}
          </template>

          <template v-slot:item.actions="{ item }">
            <!-- 明细 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="info"
                  class="px-2 me-2"
                  :href="'/#/stock-outs/' + item.id"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("StockOuts.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("StockOuts.detail")]) }}</span>
            </v-tooltip>

            <!-- 导出 -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  dark
                  color="print"
                  class="px-2 me-2"
                  @click="Export(item.id)"
                >
                  <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                  {{ $t("StockOuts.export") }}
                </v-btn>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("StockOuts.export")]) }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.cancel_flg == 1 ? 'danger' : 'primary'"
              :text-color="item.status | outStatusTextColor"
            >
              <span v-if="item.cancel_flg != 1">
                {{ item.status | outStatusText }}
              </span>
              <span v-if="item.cancel_flg == 1">
                {{ item.cancel_flg | cancelFlgsText }} {{ "("
                }}{{ item.status | outStatusText }}{{ ")" }}
              </span>
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <!-- </v-slide-x-transition> -->
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import StockOuts from "@/api/stock_outs";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_order_code: "",
  status: [2, 3],
  cancel_flgs: [0, 1],
};

export default {
  data: () => ({
    loading: false,

    options: JSON.parse(JSON.stringify(defaultOptions)),
    stock_order_code: "",
    paging: {},

    stock_outs: [],
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    accountName() {
      if (this.accountInfo) {
        return this.accountInfo.account_name;
      }
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockOuts"),
        disabled: false,
        href: "/stock-outs",
      },
      {
        text: i18n.t("Nav.stockOutsIndex"),
        disabled: true,
        href: "/stock-outs",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("StockOuts.Fields.created_time"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("StockOuts.Fields.stock_order_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockOuts.Fields.name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("StockOuts.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("StockOuts.Fields.out_status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    ...mapState(["accountInfo", "accountUser"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("stock_outs").then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },
  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        stock_order_code: this.stock_order_code,
      });
      this.getStockOutsFromAPI();
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.getStockOutsFromAPI();
    },

    getStockOutsFromAPI() {
      this.loading = true;
      StockOuts.fetch(this.id, Object.assign(this.options, { type: 13 })).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_outs;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    // 批量
    Exports() {
      StockOuts.exports(Object.assign({}, this.options));
    },
    // 单个
    Export(id) {
      StockOuts.exportOne(Object.assign(id));
    },
  },
  watch: {
    accountUser: {
      handler() {
        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          this.getStockOutsFromAPI();
        }
      },
    },
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem(
          "stock_outs-options",
          JSON.stringify(this.options)
        );
        if (this.accountUser && this.accountUser.supplier_id) {
          this.id = this.accountUser.supplier_id;
          this.getStockOutsFromAPI();
        }
      },
    },
  },
};
</script>

<style>
</style>